import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { NgModule } from '@angular/core';

import { DialogService } from './dialog';
import { DialogCloserDirective } from './dialog-closer.directive';
import { DialogContainerComponent } from './dialog-container';

@NgModule({
  imports: [OverlayModule, PortalModule, DialogCloserDirective],
  exports: [DialogContainerComponent, DialogCloserDirective, OverlayModule],
  declarations: [DialogContainerComponent],
  providers: [DialogService],
})
export class DialogModule {}
